import { apiRequest } from "./client";

export const promotionsApi = {
  list(projectId) {
    return apiRequest(`/projects/${projectId}/promotions`);
  },
  create(projectId, payload) {
    return apiRequest(`/projects/${projectId}/promotions`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  update(projectId, promotionId, payload) {
    return apiRequest(`/projects/${projectId}/promotions/${promotionId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },
  remove(projectId, promotionId) {
    return apiRequest(`/projects/${projectId}/promotions/${promotionId}`, {
      method: "DELETE",
    });
  },
};
